export const MAIN_MENU_COLLAPSED_LOCAL_STORAGE_KEY = "mainMenuCollapsed";
